import { HorizontalTabLinkProps } from '../..'
import { getMessagesTabProps } from '../../../pages/messages/constants'
import { OWNINFO_TAB_PROPS } from '../../../pages/own-info/constants'
import * as ROUTES from '../../../routes/constants/routeConstants'
import { TopBarSubMenuProps, TopBarTopLinkProps } from '../types'

const getTopBarSubMenuProps = (
  tabProps: HorizontalTabLinkProps[]
): TopBarSubMenuProps[] =>
  tabProps.map((tabProp) => {
    const { isHidden, key, to, translationId } = tabProp
    return { isHidden, key, to, translationId }
  })

// TODO change this to const TOP_BAR_NAVIGATION_LINKS, when admin tool is in use
export const getTopBarNavigationLinks = (
  useAdminTool: boolean
): TopBarTopLinkProps[] => [
  {
    exact: true,
    key: 'front',
    translationId: 'pages.frontPage.label',
    to: ROUTES.ROUTE_MAINPAGE
  },
  {
    exact: false,
    key: 'owninfo',
    subMenu: getTopBarSubMenuProps(OWNINFO_TAB_PROPS),
    translationId: 'pages.ownInfoPage.label',
    to: ROUTES.ROUTE_OWNINFO
  },
  {
    exact: true,
    key: 'membership-fees',
    translationId: 'pages.membershipFeesPage.label',
    to: ROUTES.ROUTE_MEMBERSHIP_FEES
  },
  {
    exact: true,
    key: 'messages',
    subMenu: getTopBarSubMenuProps(getMessagesTabProps(useAdminTool)),
    translationId: 'pages.messagesPage.label',
    to: ROUTES.ROUTE_MESSAGES
  }
]
